var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTop = function SvgTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 462,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16.843h462L437.692 5.888l-21.03-1.934-28.822 5.423-28.94-3.489-17.376 3.489-15.917-5.423-34.009 1.934-34.007 2.536-28.783-6.373-24.876 4.666-9.117-4.666-31.518 8.2-29.78-1.827h-27.916L51.645 0 19.528 5.888 0 16.843Z",
    fill: "#fff"
  })));
};

export default SvgTop;